import React, { useState, useEffect } from 'react';

const API_BASE = "https://api.anti-bot.ai";

const THREAT_CONFIG = {
  high:   { color: '#E53E3E', bg: 'rgba(229,62,62,0.1)',  label: 'גבוה' },
  medium: { color: '#D69E2E', bg: 'rgba(214,158,46,0.1)', label: 'בינוני' },
  low:    { color: '#38A169', bg: 'rgba(56,161,105,0.1)', label: 'נמוך' },
};

function getThreat(pct) {
  if (pct >= 60) return 'high';
  if (pct >= 30) return 'medium';
  return 'low';
}

export default function HashtagMonitor() {
  const [data, setData]         = useState([]);
  const [loading, setLoading]   = useState(true);
  const [error, setError]       = useState(null);
  const [selected, setSelected] = useState(null);
  const [lastUpdate, setLastUpdate] = useState(null);

  const fetchData = async () => {
    try {
      setLoading(true);
      const res = await fetch(`${API_BASE}/hashtags/hashtags`);
      const json = await res.json();
      if (json.success) {
        setData(json.data);
        setLastUpdate(new Date().toLocaleTimeString('he-IL'));
        setError(null);
      }
    } catch (e) {
      setError('לא ניתן להתחבר לשרת');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
    const interval = setInterval(fetchData, 10 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  if (loading && data.length === 0) return (
    <div style={{ padding: '28px 24px', direction: 'rtl', background: 'transparent', minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 16 }}>
      <div style={{ width: 48, height: 48, borderRadius: '50%', border: '3px solid #D89B5A', borderTopColor: 'transparent', animation: 'spin 1s linear infinite' }} />
      <p style={{ color: '#B7A99A', fontSize: 14 }}>מחלץ האשטאגים מטוויטר...</p>
      <style>{`@keyframes spin { from{transform:rotate(0deg)} to{transform:rotate(360deg)} }`}</style>
    </div>
  );

  return (
    <div style={{ padding: '28px 24px', direction: 'rtl', fontFamily: "'Segoe UI', Tahoma, sans-serif", background: 'transparent', minHeight: '100vh' }}>

      {/* Header */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 28 }}>
        <div>
          <h1 style={{ color: '#F3E7D7', fontSize: 22, fontWeight: 700, margin: 0 }}>
            מעקב האשטאגים
          </h1>
          <p style={{ color: '#B7A99A', fontSize: 13, margin: '4px 0 0' }}>
            זיהוי קמפיינים מתואמים בזמן אמת
          </p>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          {lastUpdate && (
            <span style={{ color: 'rgba(183,169,154,0.55)', fontSize: 12 }}>עדכון אחרון: {lastUpdate}</span>
          )}
          <button
            onClick={fetchData}
            disabled={loading}
            style={{
              background: loading ? 'rgba(74,63,55,0.4)' : 'linear-gradient(135deg, #C8904A, #D89B5A)',
              border: 'none', borderRadius: 8, padding: '8px 16px',
              color: 'white', fontSize: 13, fontWeight: 600, cursor: loading ? 'default' : 'pointer'
            }}
          >
            {loading ? 'טוען...' : 'רענן'}
          </button>
        </div>
      </div>

      {error && (
        <div style={{ background: 'rgba(229,62,62,0.1)', border: '1px solid rgba(229,62,62,0.3)', borderRadius: 12, padding: 14, marginBottom: 20, color: '#FC8181' }}>
          ❌ {error}
        </div>
      )}

      {/* כרטיסיות האשטאגים */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 16, marginBottom: 28 }}>
        {data.map((item) => {
          const threat     = getThreat(item.bot_percentage);
          const cfg        = THREAT_CONFIG[threat];
          const isSelected = selected?.hashtag === item.hashtag;

          return (
            <div
              key={item.hashtag}
              onClick={() => setSelected(isSelected ? null : item)}
              style={{
                background: isSelected ? cfg.bg : '#26211D',
                border: `1px solid ${isSelected ? cfg.color : '#4A3F37'}`,
                borderRadius: 14, padding: 20, cursor: 'pointer',
                transition: 'all 0.2s'
              }}
            >
              {/* שם האשטאג */}
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
                <span style={{ color: '#D89B5A', fontSize: 16, fontWeight: 700 }}>{item.hashtag}</span>
                <span style={{
                  background: cfg.bg, color: cfg.color,
                  border: `1px solid ${cfg.color}44`,
                  borderRadius: 20, padding: '2px 10px', fontSize: 11, fontWeight: 700
                }}>
                  {cfg.label}
                </span>
              </div>

              {/* מספרים */}
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, marginBottom: 14 }}>
                <div style={{ background: 'rgba(18,15,13,0.6)', borderRadius: 8, padding: '8px 12px' }}>
                  <div style={{ color: '#B7A99A', fontSize: 10, marginBottom: 2 }}>טוויטים</div>
                  <div style={{ color: '#F3E7D7', fontSize: 18, fontWeight: 700 }}>{item.total}</div>
                </div>
                <div style={{ background: 'rgba(18,15,13,0.6)', borderRadius: 8, padding: '8px 12px' }}>
                  <div style={{ color: '#B7A99A', fontSize: 10, marginBottom: 2 }}>חשודים</div>
                  <div style={{ color: cfg.color, fontSize: 18, fontWeight: 700 }}>{item.bot_percentage}%</div>
                </div>
              </div>

              {/* בר */}
              <div style={{ height: 5, background: 'rgba(74,63,55,0.3)', borderRadius: 3, overflow: 'hidden' }}>
                <div style={{
                  height: '100%', width: `${item.bot_percentage}%`,
                  background: cfg.color, borderRadius: 3,
                  transition: 'width 1s ease'
                }} />
              </div>
            </div>
          );
        })}
      </div>

      {/* פירוט כפילויות */}
      {selected && selected.duplicates?.length > 0 && (
        <div style={{ background: '#26211D', border: '1px solid #4A3F37', borderRadius: 16, padding: 24 }}>
          <h2 style={{ color: '#F3E7D7', fontSize: 16, fontWeight: 700, marginBottom: 16 }}>
            טקסטים חוזרים ב-{selected.hashtag}
          </h2>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            {selected.duplicates.map((dup, i) => (
              <div key={i} style={{
                background: 'rgba(18,15,13,0.6)', border: '1px solid #4A3F37',
                borderRadius: 10, padding: '12px 16px',
                display: 'flex', alignItems: 'center', gap: 16
              }}>
                <div style={{
                  background: 'rgba(229,62,62,0.15)', border: '1px solid rgba(229,62,62,0.3)',
                  borderRadius: 8, padding: '6px 12px', minWidth: 60, textAlign: 'center'
                }}>
                  <div style={{ color: '#E53E3E', fontSize: 18, fontWeight: 700 }}>×{dup.count}</div>
                  <div style={{ color: '#B7A99A', fontSize: 10 }}>חזרות</div>
                </div>
                <p style={{ color: '#F3E7D7', fontSize: 13, margin: 0, lineHeight: 1.6 }}>
                  {dup.text}...
                </p>
              </div>
            ))}
          </div>
        </div>
      )}

    </div>
  );
}
